import service from '@/store/services/cart-service';
import axios from 'axios';

const state = {
  cart: [],
  loading: false,
  subTotal: 0,
  total: 0,
};

const mutations = {
  SET_LOADING: (state, payload) => {
    state.loading = payload;
  },
  SET_CART: (state, payload) => {
    state.cart = payload;
  },
  SET_CART_SUBTOTAL: (state, payload) => {
    state.subTotal = payload;
  },
  SET_CART_TOTAL: (state, payload) => {
    state.total = payload;
  },
};

const actions = {
  accessProduct({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = {
      session_id: currentSession,
      product_id: params.product_id,
      access_legacy: params.access_legacy,
    };

    return service
      .access(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  checkProductAccess({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = {
      session_id: currentSession,
      product_id: params.product_id,
    };
    if (params.locnums) {
      payload.locnums = params.locnums;
    }
    if (params.companyFilterType) {
      payload.companyFilterType = params.companyFilterType;
    }

    return service
      .checkAccess(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  checkProductAccessByType({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = {
      session_id: currentSession,
      type: params.type,
    };

    return service
      .checkAccessByType(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  list({ commit, dispatch }) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = {
      session_id: currentSession,
    };

    return service
      .list(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }       
        commit('SET_CART', res.data.items);
        commit('SET_CART_SUBTOTAL', res.data.subTotal);
        commit('SET_CART_TOTAL', res.data.total);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  removeItem({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = {
      session_id: currentSession,
      item_id: params.product_id,
    };

    return service
      .remove(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const getters = {
  cart: (state) => state.cart,
  subTotal: (state) => state.subTotal,
  total: (state) => state.total,
};

const cart = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cart;
